// @ts-nocheck
import common from "@store/Themes/common/styleguide/components/typography";
import { css } from "styled-components";

export default {
    /*
    p: {
        // Example: Reuse styles from the common theme and add new styles on top of it
        css: css`
            ${common?.p?.css}
            color: red;
        `,
    },
    */
};
